export const ActividadEconomicaOptions = [
    {text: 'Público', value: 'PUB'},
    {text: 'Privado', value: 'PRI'},
]